// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorBoundary_root__2cs_A","modal":"ErrorBoundary_modal__2LKbj","text":"ErrorBoundary_text__3AtkR"};